import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import LandingPage from "@/pages/LandingPage";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";

import AccountDashboard from "@/pages/user/AccountDashboard";
import BuyPlan from "@/pages/user/BuyPlan";
import MyPayments from "@/pages/user/MyPayments";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminPlans from "@/pages/admin/AdminPlans";
import AdminSharedAccounts from "@/pages/admin/AdminSharedAccounts";
import AdminSubscriptions from "@/pages/admin/AdminSubscriptions";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminSettings from "@/pages/admin/AdminSettings";

import { Toaster } from "@/components/ui/sonner";

const userPage = (El) => (
  <ProtectedRoute>
    <Layout>
      <El />
    </Layout>
  </ProtectedRoute>
);
const adminPage = (El) => (
  <ProtectedRoute adminOnly>
    <Layout>
      <El />
    </Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            <Route path="/account" element={userPage(AccountDashboard)} />
            <Route path="/account/plans" element={userPage(BuyPlan)} />
            <Route path="/account/payments" element={userPage(MyPayments)} />

            <Route path="/admin" element={adminPage(AdminDashboard)} />
            <Route path="/admin/users" element={adminPage(AdminUsers)} />
            <Route path="/admin/plans" element={adminPage(AdminPlans)} />
            <Route path="/admin/shared-accounts" element={adminPage(AdminSharedAccounts)} />
            <Route path="/admin/subscriptions" element={adminPage(AdminSubscriptions)} />
            <Route path="/admin/payments" element={adminPage(AdminPayments)} />
            <Route path="/admin/settings" element={adminPage(AdminSettings)} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
